import { render, staticRenderFns } from "./ChatReportMobileMenu.vue?vue&type=template&id=3ab412c0&scoped=true"
import script from "./ChatReportMobileMenu.vue?vue&type=script&lang=ts"
export * from "./ChatReportMobileMenu.vue?vue&type=script&lang=ts"
import style0 from "./ChatReportMobileMenu.vue?vue&type=style&index=0&id=3ab412c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab412c0",
  null
  
)

export default component.exports